import React, { useEffect } from "react";
import { getManagerLandingPath } from "@/shared/readOnlyManager";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { isAuthenticated, getAuthUser } from "./auth";
import { PublicFooter } from "../Layout/footer";

export const PublicRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    
      if (location.pathname !== '/loginAs' && isAuthenticated()) {
        const user = getAuthUser();
        let sentTo = "/";
        if (user.loginAs.name.includes("Manager")) {
          sentTo = getManagerLandingPath(user);
        } else if (user.loginAs.name === "Participant") {
          sentTo = "/participant/home";
        }
        navigate(sentTo);
      } else if (location.pathname === "/") {
        navigate("/login");
      }
    // else{
    //     navigate('/login')
    // }
  }, [navigate, location]);

  return (
    <>
      <main className="home">
        <Outlet />
      </main>
      <PublicFooter />
    </>
  );
};

export default PublicRoute;
